import { Container, Grid, TablePagination, makeStyles } from '@material-ui/core';
import { endOfMonth, format, startOfMonth, subDays } from 'date-fns';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import useSWR from 'swr';
import { Header } from '../../styles/shared/styles';
import { variantFetcher } from '../../service/SWRFetcher';
import Filter from '../../components/OriginLeadsReport/Filter';
import LeadsOriginTable from '../../components/OriginLeadsReport/Table';

const OriginLeadsReport = () => {
  const [filters, setFilters] = useState({
    date_start: format(startOfMonth(new Date()), 'Y-MM-dd'),
    date_end: format(endOfMonth(new Date()), 'Y-MM-dd'),
    broker_id: '',
  });

  const { data, mutate, isValidating } = useSWR(
    `/leads-origin?date_start=${filters.date_start}&date_end=${filters.date_end}&broker_id=${filters.broker_id}`,
    variantFetcher,
    { revalidateOnFocus: false }
  );

  return (
    <>
      <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
        <Container style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '1em' }}>
          <Header>
            <h1>Relatório de Origem dos Leads</h1>
          </Header>

          <Filter filters={filters} setFilters={setFilters} />

          <LeadsOriginTable brokers={data?.data || []} mutate={mutate} />
        </Container>
      </motion.div>
    </>
  );
};

export default OriginLeadsReport;
